<template>
    <div class="mermaid" ref="mermaidContainer">
      {{ graphDefinition }}
    </div>
  </template>
  
  <script>
//   import mermaid from 'mermaid';
  
  export default {
    props: {
      graphDefinition: {
        type: String,
        required: true
      }
    },
    mounted() {
      // 初始化配置（可选）
      mermaid.initialize({
        startOnLoad: false,
        theme: 'default',
        flowchart: { 
          useMaxWidth: false,
          htmlLabels: true 
        }
      });
      
      // 手动渲染
      this.renderMermaid();
    },
    methods: {
      renderMermaid() {
        try {
          mermaid.init(undefined, this.$refs.mermaidContainer);
        } catch (err) {
          console.error('Mermaid 渲染错误:', err);
        }
      }
    },
    watch: {
      // 监听数据变化重新渲染
      graphDefinition() {
        this.$nextTick(() => this.renderMermaid());
      }
    }
  };
  </script>
  
  <style scoped>
  .mermaid {
    background: white;
    padding: 20px;
    border-radius: 4px;
  }
  </style>